<template functional>
  <div class="foo" v-if="$options.customRender(props)">
    <el-avatar
      v-if="!$options.getSrcImg(props)"
      size="small"
      src="/static/images/avatar-2.jpg"
    ></el-avatar>
    <el-avatar v-else size="small" :src="$options.getSrcImg(props)"></el-avatar>
    <span>{{ $options.customRender(props) }}</span>
  </div>
</template>

<script>
import get from "lodash/get";
const arrayGet = get;
export default {
  name: "ImagePerson",
  props: {
    imgKey: {
      type: String,
      required: false,
      default: null
    },
    column: String,
    row: Object
  },
  customRender(props) {
    return arrayGet(props.row, props.column);
  },
  getSrcImg(props) {
    return arrayGet(props.row, props.imgKey);
  }
};
</script>

<style scoped>
.foo {
  height: auto;
}
.foo span {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
}
.foo span:first-child {
  margin-right: var(--flex-gap, 0.5em);
}
</style>
